<template>
  <div v-if="loaded" class="app flex-row align-items-center main-view">
    <div class="container multi-card-container" :style="$route.name === 'BlogView' ? { marginTop: 0 } : ''">
      <div class="row">
        <div class="col-12">
          <h1>{{ $route.name === 'BlogView' ? $t('blogs_webview_title') : $t('blogs_title') }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12 card-col article-block flex-column">
          <div v-if="spinners.contentIsLoading" class="card-ct card-rounded-shadowed text-center">
            <b-spinner type="grow" variant="primary"/>
          </div>
          <BlogEntry v-else v-for="blog in blogs" :title="blog.title" :content="blog.content"/>
          <div v-if="!spinners.contentIsLoading && !blogs.length" class="card-ct card-rounded-shadowed">
            <h2>{{ $t('blogs_no_entries') }}</h2>
          </div>
        </div>
        <div class="col-12">
          <Pagination :data="blogsMetaData"
                      :limit="5"
                      @pagination-change-page="onPageChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlogEntry from '@/components/Blog/BlogEntry';
import Pagination from 'laravel-vue-pagination';
import { mapGetters, mapActions } from 'vuex';
import VuexTypes from '@/store/types/index';
import Vue from 'vue';
import statuses from '@/store/statuses';
import forEach from 'lodash.foreach';
import { Backend } from '@/_axios';

const BlogsTypes = VuexTypes.blogs;
const TranslationsTypes = VuexTypes.translations;

export default {
  components: {
    BlogEntry,
    Pagination
  },
  props: ['page'],
  data () {
    return {
      spinners: {
        contentIsLoading: true,
      },
      blogs: [],
      blogsMetaData: {},
      lang: this.$route.query.lang,
      loaded: false
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.params.page !== from.params.page) {
        this.getData();
      }
    },
    blogsList: {
      handler() {
        if (this.blogsList.status === statuses.LOADED) {
          this.fillData();
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
    language(val, oldVal) {
      this.getData();
    },
  },
  mounted () {
    if (this.lang) {
      Backend.defaults.headers.common['Accept-Language'] = this.lang;
      this.TRANSLATIONS().then((res) => {
        Vue.set(this, 'loaded', true);
        this.getData();
      });
    } else {
      this.getData();
      Vue.set(this, 'loaded', true);
    }
  },
  computed: {
    ...mapGetters('Blogs', [
      'blogsList',
    ]),
    ...mapGetters('Translations', ['language']),
  },
  methods: {
    ...mapActions('Blogs', [
      BlogsTypes.BLOGS_LIST,
    ]),
    ...mapActions('Translations', [
      TranslationsTypes.TRANSLATIONS,
      TranslationsTypes.SET_LANG
    ]),
    getData() {
      this.spinners.contentIsLoading = true;
      this.BLOGS_LIST(this.page);
    },
    fillData() {
      const result = [];

      forEach(this.blogsList.data.data, item => {
        result.push({
          title: item.texts.title,
          content: item.texts.html_content
        });
      });

      this.blogs = result;
      this.blogsMetaData = this.blogsList.data.meta;
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page) {
        this.$router.push({ name: 'Blog', params: { page } });
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.app.flex-row.align-items-center {
  .container.multi-card-container {
    margin-bottom: 0;
  }
}
</style>